import { Stack } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { InfoBox } from '../../users-components/InfoBox';
import { BackToLogin } from './BackToLogin';

export const PasswordResetSuccessMessage: React.FC = () => {
  return (
    <>
      <Stack direction="column" spacing={4} sx={{ width: '456px' }}>
        <VyIcon icon="LogoBlue" className="text-transparent" />
        <InfoBox
          title="All done!"
          description="Your password has been successfully reset. You can now log in with your new password."
        />
        <BackToLogin />
      </Stack>
    </>
  );
};
